/**
 * Global UI text translations.
 *
 * Structure: { HEB: {...}, ENG: {...} }
 *
 * Components that currently import `Text` and use `Text.someKey` directly
 * should migrate to `const { t } = useLanguage(); t(Text).someKey`.
 * Until migrated, they can keep using `Text.HEB.someKey` (identical to before).
 */

const _shared = {
  HEB: {
    settingTitle: "ניהול חשבון",
    upgradeToPremuim: "שדרגו לפרימיום",
    joinDateText: "תאריך הצטרפות למערכת",
    expireDateText: "תאריך סיום המנוי",
    expireDate: "ללא",
    featureText: "פיצ'ר",
    programText: "Premium",
    freeFeaureText: "Free",
    deleteAccount: "מחק חשבון ומידע",
    debatingContact: "מתלבטים? צרו איתנו קשר",
    termsOfUse: "תנאי שימוש",
    privacyPolicy: "מדיניות פרטיות",
    editPersonalDetails: "עריכת פרטים אישיים",
    commitments: "התחייבויות",
    assets: "נכסים",
    addButton: "הוספה",
    showDetailsText: "הצג פירוט",
    details: "פירוט",
    showSumAssetsText: "הצג סיכום",
    summary: "סיכום",
    filterText: "סינון",
    readMore: "קרא עוד",
    readLess: "קרא פחות",
    all: "הכל",
    unread: "לא נקראו",
    improvementSuggestions: "ההצעות שלנו לייעול",
    improvmenetSuggestions1: "מצאנו",
    improvmenetSuggestions2: "דרכים להתייעל",
    improvementSuggestionsDesc: "לפניכם תובנות שהמערכת מצאה בהתאם לנתונים האישיים שלכם, כדי למקסם את הגדילה הכלכלית שלכם. ככל שתוסיפו יותר נתונים יתווספו יותר דרכים לייעול, לחיצה על תובנה תציג הסבר מפורט יותר.",
    unreadInsights: "תובנות שלא נקראו",
    readInsights: "תובנות שנקראו",
    fullName: "שם מלא",
    phone: "טלפון",
    mail: "מייל",
    comments: "הערות",
    thanks: "תודה",
    callMeBack: "חזרו אליי",
    messageWasSendWeCallYouBack: "ההודעה נשלחה בהצלחה, נחזור אליך בהקדם!",
    shouldWeCallYouBackWithAllDetails: "הטלפון שלך ליצירת הקשר 📞",
    showValueAfterTax: "הצגת שווי לאחר מס",
    notificationManagement: "ניהול התראות",
    allowNotifications: "אפשר התראות",
    allowInsightNotifications: "אפשר התראות על תובנות",
    allowMaslekaNotfications: "אפשר התראות על מסלקה",
    allowMonthlyNotifications: "אפשר הודעת סטטוס חודשיות",
    yesefTax: "מס יסף",
    offsetLosses: "קזז הפסדי הון",
    showValueAfterSellingInTwoYears: "זמן מכירה",
    showVestedOnly: "הצגת רק השווי של מה שהבשיל",
    formCantBeSend: "מצטערים, יש כרגע בעיה טכנית לשלוח את הטופס... בינתיים, אפשר להמשיך לצפות בתובנות!",
    keepWatchInsights: "להמשך צפיה בתובנות",
    shareSymbol: "יש לחפש מניה לפי הסימול שלה",
    temporaryPremiumFree: "מנוי הפרמיום שלנו עדין בתהליכי פיתוח, בינתיים השירות הוא חינמי לכולם :)",
    featureNames: {
      addAssets: "הוספת נכסים ללא הגבלה",
      customAssets: "התאמה אישית בניהול הנכסים",
      automaticAdjustment: 'שיערוך אוטומטי לנכסי נדל"ן - בישראל ובריטניה',
      crypto: "חיבור ארנק קריפטו",
      automaticUpdateCrypto: "עדכון אוטומטי שווי ארנקי קריפטו",
      connectBankAccount: "חיבור חשבונות עו\"ש - בישראל ובריטניה",
      automaticValue: "עדכון שווי אוטומטי מניות",
      automaticValueCrypto: "עדכון שווי אוטומטי מטבעות קריפטו",
      updateReturns: "עדכון תשואות מגמל נט",
      automaticImport: "ייבוא אוטומטי של נכסים פנסיונים",
      webinarOrder: "הזמנה לוובינרים על ניהול פיננסי נכון",
      financialPlanning: "תכנון פיננסי",
      appAccess: "גישה דרך האפליקציה",
      webAccess: "גישה דרך האתר האינטרנטי",
      smartInsights: "קבלת תובנות חכמות",
      InsightsFiter: "פילטר תובנות",
      currencySupport: "תמיכה בכל שערי המטבע"
    },
    featureValues: {
      oneTime: "חד פעמי",
      daily: "יומי",
      everyEightHours: "כל 8 שעות",
      weekly: "שבועי",
      monthly: "חודשי",
      discount: "בהנחה",
      allInsight: "כלל התובנות",
      yourInsights: "התובנות שלך",
      continuous: "רציף",
      limited: "מוגבל"
    },
    errors: {
      invalidName: "אנחנו צריכים לדעת איך לפנות אלייך",
      invalidEmail: "המייל שהוזן לא תקין",
      invalidPhone: "מספר הטלפון שהוזן לא תקין",
      saveDetailsError: "שגיאה בשמירת הפרטים",
      detailsSavedSuccess: "הפרטים נשמרו בהצלחה",
      idNumberTakenOtherPhone: "משתמש אחר קשור למספר תעודת הזהות הזה עם מספר טלפון שונה. לא ניתן לעדכן.",
      idNumberMoveOffer: "לחשבון אחר שלך (אימייל: {email}) כבר מוגדר מספר תעודת זהות זה. להעביר את מספר תעודת הזהות לחשבון הנוכחי?",
      idNumberMoveConfirm: "העברת מספר תעודת זהות לחשבון זה",
      idNumberMoveCancel: "ביטול",
      idNumberMoveOfferHasMaslekaIntro: "לחשבון האחר שלך (אימייל: {email}) כבר מוגדר מספר תעודת זהות זה, ובחשבון זה בוצע מסלקה בתאריך {date}.",
      idNumberMoveOfferHasMaslekaWarning: "אם תעביר את מספר תעודת הזהות לחשבון הנוכחי – עדכוני המסלקה יפסיקו להגיע לחשבון האחר. האם להמשיך?",
    },
    deleteUserAccount: {
      leave: "עוזבים?",
      moumentBeforeHowCanWeImprovement: "רגע לפני, איך נוכל להשתפר?",
      continue: "המשך",
      coluldNotDeleteAccount: "מצטערים, יש לנו כרגע בעיה טכנית לשלוח את הטופס... נסו שוב בעוד כמה רגעים",
      undrestendThanks: "הבנתי, תודה",
      deleteAccountFromApp: "האם למחוק את החשבון מהאפליקציה",
      cantRestore: "לאחר לחיצה על \"מחיקת חשבון\" לא יהיה ניתן לשחזר את הנכסים שהוזנו",
      deleteAccount: "מחיקת חשבון",
      regret: "התחרטתי",
      whatIsDisturbingYou: "מה מפריע לי?",
      whatWasYourExpectation: "מה היו הציפיות שלי?",
      leaveReasons: {
        price: "יקר לי ביחס לתועלת",
        not_using: "אני כבר לא משתמש/ת במאניטור",
        bank_not_supported: "הבנק או הגוף הפיננסי שלי לא נתמך",
        data_issues: "בעיות בנתונים, בסנכרון או בחיבורים",
        missing_feature: "חסר לי פיצ'ר שחשוב לי",
        too_complicated: "מסובך מדי / לא הבנתי איך להשתמש",
        privacy: "חששות של פרטיות או אבטחה",
        competitor: "עברתי לפתרון אחר",
        done_checking: "באתי לבדוק וסיימתי",
        other: "אחר (נשמח שתפרטו)",
      },
        reasonRequired: "כדי שנוכל להשתפר, בחרו סיבה לעזיבה",
        otherReasonRequiresText: "בחרתם 'אחר' - נשמח שתפרטו במילים שלכם",
    },
    generalError: {
      errorContext: "אוי קרתה שגיאה, זה לא אתם זה אנחנו :) ניתן לחזור לעמוד הקודם, או לנסות שוב במועד מאוחר יותר, בינתיים אנחנו נפתור את הבעיה!",
      returnButton: "חזרה"
    },
    stockInfo: {
      yesefText: "רלוונטי למי שהכנסתו עולה על 721,560 ברוטו בשנת מס. (נכון ל2025) סימון מס יסף יעלה את מס רווחי ההון ב5% בחישוב השווי הסופי",
      offsetLosses: "אם קיימים הפסדי הון בתיק - ניתן לקזז אותם מהמיסים על רווחי ההון. סימון זה ידאג לקזז את ההפסדים מהמס לפי פרופורצית הרווחים של כל מניה"
    },
    rsuInfo: {
      yesefText: "רלוונטי למי שהכנסתו עולה על 721,560 ברוטו בשנת מס. (נכון ל2025) סימון מס יסף יעלה את המס השולי ב3% ואת מס רווחי ההון ב5% בחישוב השווי הסופי",
      twoyearsRSU: "כדי להינות ממס הוני (25%) על ההפרש בין המחיר בזמן ההקצאה למחיר הנוכחי יש לחכות שנתיים מרגע ההקצעה ועד רגע המכירה. אם סימנת את זמן המכירה כ״מיידי״ ההנחה היא שעל כל ההקצאות החדשות יחול מס שולי",
      twoyearsOption: "במימוש אופציות יש לחכות שנתיים לפחות מיום ההקצאה כדי להינות ממס ״הוני״ (25%). במידה וסימנת ״מיידית״ ההנחה תהיה שעל אופציות שהוקצו לפני פחות משנתיים יחול מס שולי",
      IPOMessage: "השדות האלה רלוונטיים רק במקרה והחברה מונפקת וקיבלת הענקה של אופציות פחות מ90 יום לפני תאריך ההנפקה"
    },
    shareForm: {
      uninvestedCash: "מזומן לא מושקע",
      minimumFee: "עמלת מינימום",
      custodyFee: "דמי משמרת",
      securityName: "שם נייר ערך",
      price: "מחיר",
      ipoDate: "תאריך IPO",
      ipoPrice: "מחיר IPO",
      marginalTaxBracket: "מדרגת מס שולי",
      afterTwoYears: "לאחר שנתיים",
      immediate: "מיידית",
    },
    formLabels: {
      firstName: "שם פרטי",
      lastName: "שם משפחה",
      idNumber: "מספר תעודת זהות",
      email: "אימייל",
      phone: "טלפון",
      save: "שמירה",
      saving: "שומר...",
      address: "כתובת",
      personalDetails: "פרטים אישיים"
    }
  },
  ENG: {
    settingTitle: "Account management",
    upgradeToPremuim: "Upgrade to Premium",
    joinDateText: "Registration date",
    expireDateText: "Subscription end date",
    expireDate: "None",
    featureText: "Feature",
    programText: "Premium",
    freeFeaureText: "Free",
    deleteAccount: "Delete account and data",
    debatingContact: "Unsure? Contact us",
    termsOfUse: "Terms of use",
    privacyPolicy: "Privacy policy",
    editPersonalDetails: "Edit personal details",
    commitments: "Liabilities",
    assets: "Assets",
    addButton: "Add",
    showDetailsText: "Show details",
    details: "Details",
    showSumAssetsText: "Show summary",
    summary: "Summary",
    filterText: "Filter",
    readMore: "Read more",
    readLess: "Read less",
    all: "All",
    unread: "Unread",
    improvementSuggestions: "Our optimization suggestions",
    improvmenetSuggestions1: "We found",
    improvmenetSuggestions2: "ways to optimize",
    improvementSuggestionsDesc: "Here are insights the system found based on your personal data to maximize your financial growth. The more data you add, the more optimization opportunities will appear. Clicking an insight will show a more detailed explanation.",
    unreadInsights: "Unread insights",
    readInsights: "Read insights",
    fullName: "Full name",
    phone: "Phone",
    mail: "Email",
    comments: "Comments",
    thanks: "Thank you",
    callMeBack: "Get Back to Me",
    messageWasSendWeCallYouBack: "Message sent successfully, we'll get back to you soon!",
    shouldWeCallYouBackWithAllDetails: "Your phone number for contact 📞",
    showValueAfterTax: "Show value after tax",
    notificationManagement: "Manage notifications",
    allowNotifications: "Enable notifications",
    allowInsightNotifications: "Enable insight notifications",
    allowMaslekaNotfications: "Enable Masleka notifications",
    allowMonthlyNotifications: "Enable monthly status messages",
    yesefTax: "Surtax",
    offsetLosses: "Offset capital losses",
    showValueAfterSellingInTwoYears: "Selling time",
    showVestedOnly: "Show only vested value",
    formCantBeSend: "Sorry, there's a technical issue sending the form... In the meantime, you can continue viewing insights!",
    keepWatchInsights: "Continue viewing insights",
    shareSymbol: "Search for a stock by its ticker symbol",
    temporaryPremiumFree: "Our premium subscription is still in development. In the meantime, the service is free for everyone :)",
    featureNames: {
      addAssets: "Unlimited asset addition",
      customAssets: "Custom asset management",
      automaticAdjustment: "Automatic real estate valuation - Israel & UK",
      crypto: "Crypto wallet connection",
      automaticUpdateCrypto: "Automatic crypto wallet valuation",
      connectBankAccount: "Bank account connection - Israel & UK",
      automaticValue: "Automatic stock valuation",
      automaticValueCrypto: "Automatic crypto coin valuation",
      updateReturns: "Return updates from Gamal Net",
      automaticImport: "Automatic pension asset import",
      webinarOrder: "Financial management webinar invitations",
      financialPlanning: "Financial planning",
      appAccess: "App access",
      webAccess: "Website access",
      smartInsights: "Smart insights",
      InsightsFiter: "Insights filter",
      currencySupport: "All currency support"
    },
    featureValues: {
      oneTime: "One-time",
      daily: "Daily",
      everyEightHours: "Every 8 hours",
      weekly: "Weekly",
      monthly: "Monthly",
      discount: "Discounted",
      allInsight: "All insights",
      yourInsights: "Your insights",
      continuous: "Continuous",
      limited: "Limited"
    },
    errors: {
      invalidName: "We need to know how to address you",
      invalidEmail: "The email entered is invalid",
      invalidPhone: "The phone number entered is invalid",
      saveDetailsError: "Error saving details",
      detailsSavedSuccess: "Details saved successfully",
      idNumberTakenOtherPhone: "Another user is linked to this ID number with a different phone number. You cannot update it.",
      idNumberMoveOffer: "Your other account (email: {email}) already has this ID number. Move this ID number to your current account?",
      idNumberMoveConfirm: "Move ID number to this account",
      idNumberMoveCancel: "Cancel",
      idNumberMoveOfferHasMaslekaIntro: "Your other account (email: {email}) already has this ID number, and that account has Masleka from {date}.",
      idNumberMoveOfferHasMaslekaWarning: "If you move the ID number to this account, Masleka updates will stop arriving for the other account. Continue?",
    },
    deleteUserAccount: {
      leave: "Leaving?",
      moumentBeforeHowCanWeImprovement: "Before you go, how can we improve?",
      continue: "Continue",
      coluldNotDeleteAccount: "Sorry, we're having a technical issue... Please try again in a moment",
      undrestendThanks: "Got it, thanks",
      deleteAccountFromApp: "Delete account from the app?",
      cantRestore: "After clicking \"Delete account\" you won't be able to recover the assets entered",
      deleteAccount: "Delete account",
      regret: "Changed my mind",
      whatIsDisturbingYou: "What bothers me?",
      whatWasYourExpectation: "What were my expectations?",
      leaveReasons: {
        price: "Too expensive for the value",
        not_using: "I no longer use Moneytor",
        bank_not_supported: "My bank or provider is not supported",
        data_issues: "Data, sync or connection problems",
        missing_feature: "Missing a feature I need",
        too_complicated: "Too complicated / hard to figure out",
        privacy: "Privacy or security concerns",
        competitor: "Switched to another solution",
        done_checking: "Just came to check it out, I am done",
        other: "Other (please tell us)",
      },
        reasonRequired: "Please pick a reason so we can improve",
        otherReasonRequiresText: "You chose 'Other', please tell us more",
    },
    generalError: {
      errorContext: "Oops, an error occurred - it's not you, it's us :) You can go back to the previous page or try again later. We'll fix the issue!",
      returnButton: "Back"
    },
    stockInfo: {
      yesefText: "Relevant for those earning over 721,560 NIS gross per tax year (as of 2025). Marking surtax will increase capital gains tax by 5% in the final value calculation",
      offsetLosses: "If there are capital losses in the portfolio, they can be offset against capital gains tax. This will offset losses proportionally to each stock's profits"
    },
    rsuInfo: {
      yesefText: "Relevant for those earning over 721,560 NIS gross per tax year (as of 2025). Marking surtax will increase marginal tax by 3% and capital gains tax by 5%",
      twoyearsRSU: "To benefit from capital gains tax (25%) on the difference between grant price and current price, you must wait two years from grant to sale. If you marked selling time as \"immediate\", marginal tax will apply to all new grants",
      twoyearsOption: "When exercising options, you must wait at least two years from grant date for capital gains tax (25%). If you marked \"immediate\", marginal tax applies to options granted less than two years ago",
      IPOMessage: "These fields are relevant only if the company is public and you received an option grant less than 90 days before the IPO date"
    },
    shareForm: {
      uninvestedCash: "Uninvested cash",
      minimumFee: "Minimum fee",
      custodyFee: "Custody fee",
      securityName: "Security name",
      price: "Price",
      ipoDate: "IPO date",
      ipoPrice: "IPO price",
      marginalTaxBracket: "Marginal tax bracket",
      afterTwoYears: "After two years",
      immediate: "Immediate",
    },
    formLabels: {
      firstName: "First name",
      lastName: "Last name",
      idNumber: "ID number",
      email: "Email",
      phone: "Phone",
      save: "Save",
      saving: "Saving...",
      address: "Address",
      personalDetails: "Personal details"
    }
  },
  RUS: {
    settingTitle: "Управление аккаунтом",
    upgradeToPremuim: "Перейти на Premium",
    joinDateText: "Дата регистрации",
    expireDateText: "Дата окончания подписки",
    expireDate: "Нет",
    featureText: "Функция",
    programText: "Premium",
    freeFeaureText: "Free",
    deleteAccount: "Удалить аккаунт и данные",
    debatingContact: "Сомневаетесь? Свяжитесь с нами",
    termsOfUse: "Условия использования",
    privacyPolicy: "Политика конфиденциальности",
    editPersonalDetails: "Редактировать личные данные",
    commitments: "Обязательства",
    assets: "Активы",
    addButton: "Добавить",
    showDetailsText: "Показать детали",
    details: "Детали",
    showSumAssetsText: "Показать итоги",
    summary: "Итоги",
    filterText: "Фильтр",
    readMore: "Читать далее",
    readLess: "Свернуть",
    all: "Все",
    unread: "Непрочитанные",
    improvementSuggestions: "Наши предложения по оптимизации",
    improvmenetSuggestions1: "Мы нашли",
    improvmenetSuggestions2: "способов оптимизации",
    improvementSuggestionsDesc: "Перед вами инсайты, которые система нашла на основе ваших личных данных для максимизации финансового роста. Чем больше данных вы добавите, тем больше возможностей для оптимизации появится. Нажмите на инсайт для подробного объяснения.",
    unreadInsights: "Непрочитанные инсайты",
    readInsights: "Прочитанные инсайты",
    fullName: "Полное имя",
    phone: "Телефон",
    mail: "Эл. почта",
    comments: "Комментарии",
    thanks: "Спасибо",
    callMeBack: "Перезвоните мне",
    messageWasSendWeCallYouBack: "Сообщение успешно отправлено, мы свяжемся с вами в ближайшее время!",
    shouldWeCallYouBackWithAllDetails: "Ваш телефон для связи 📞",
    showValueAfterTax: "Показать стоимость после налога",
    notificationManagement: "Управление уведомлениями",
    allowNotifications: "Включить уведомления",
    allowInsightNotifications: "Включить уведомления об инсайтах",
    allowMaslekaNotfications: "Включить уведомления Маслека",
    allowMonthlyNotifications: "Включить ежемесячные отчёты",
    yesefTax: "Дополнительный налог",
    offsetLosses: "Зачёт убытков капитала",
    showValueAfterSellingInTwoYears: "Срок продажи",
    showVestedOnly: "Показать только вестированную стоимость",
    formCantBeSend: "Извините, возникла техническая проблема с отправкой формы... Тем временем вы можете продолжить просмотр инсайтов!",
    keepWatchInsights: "Продолжить просмотр инсайтов",
    shareSymbol: "Найдите акцию по тикеру",
    temporaryPremiumFree: "Наша премиум-подписка ещё в разработке. Пока сервис бесплатен для всех :)",
    featureNames: {
      addAssets: "Безлимитное добавление активов",
      customAssets: "Настраиваемое управление активами",
      automaticAdjustment: "Автоматическая оценка недвижимости — Израиль и Великобритания",
      crypto: "Подключение крипто-кошелька",
      automaticUpdateCrypto: "Автоматическая оценка крипто-кошелька",
      connectBankAccount: "Подключение банковских счетов — Израиль и Великобритания",
      automaticValue: "Автоматическая оценка акций",
      automaticValueCrypto: "Автоматическая оценка криптовалют",
      updateReturns: "Обновление доходности из Гамаль Нет",
      automaticImport: "Автоматический импорт пенсионных активов",
      webinarOrder: "Приглашения на вебинары по финансовому управлению",
      financialPlanning: "Финансовое планирование",
      appAccess: "Доступ через приложение",
      webAccess: "Доступ через сайт",
      smartInsights: "Умные инсайты",
      InsightsFiter: "Фильтр инсайтов",
      currencySupport: "Поддержка всех валют"
    },
    featureValues: {
      oneTime: "Разово",
      daily: "Ежедневно",
      everyEightHours: "Каждые 8 часов",
      weekly: "Еженедельно",
      monthly: "Ежемесячно",
      discount: "Со скидкой",
      allInsight: "Все инсайты",
      yourInsights: "Ваши инсайты",
      continuous: "Непрерывно",
      limited: "Ограничено"
    },
    errors: {
      invalidName: "Нам нужно знать, как к вам обращаться",
      invalidEmail: "Введён некорректный адрес эл. почты",
      invalidPhone: "Введён некорректный номер телефона",
      saveDetailsError: "Ошибка при сохранении данных",
      detailsSavedSuccess: "Данные успешно сохранены",
      idNumberTakenOtherPhone: "Другой пользователь связан с этим номером удостоверения с другим номером телефона. Обновление невозможно.",
      idNumberMoveOffer: "Ваш другой аккаунт (email: {email}) уже имеет этот номер удостоверения. Перенести номер удостоверения на текущий аккаунт?",
      idNumberMoveConfirm: "Перенести номер удостоверения на этот аккаунт",
      idNumberMoveCancel: "Отмена",
      idNumberMoveOfferHasMaslekaIntro: "Ваш другой аккаунт (email: {email}) уже имеет этот номер удостоверения, и в том аккаунте была оформлена Маслека {date}.",
      idNumberMoveOfferHasMaslekaWarning: "Если вы перенесёте номер удостоверения на текущий аккаунт, обновления Маслека перестанут приходить на другой аккаунт. Продолжить?",
    },
    deleteUserAccount: {
      leave: "Уходите?",
      moumentBeforeHowCanWeImprovement: "Прежде чем уйти, как мы можем стать лучше?",
      continue: "Продолжить",
      coluldNotDeleteAccount: "Извините, возникла техническая проблема... Попробуйте ещё раз через несколько минут",
      undrestendThanks: "Понятно, спасибо",
      deleteAccountFromApp: "Удалить аккаунт из приложения?",
      cantRestore: "После нажатия «Удалить аккаунт» восстановить введённые активы будет невозможно",
      deleteAccount: "Удалить аккаунт",
      regret: "Передумал",
      whatIsDisturbingYou: "Что мне мешает?",
      whatWasYourExpectation: "Какие у меня были ожидания?",
      leaveReasons: {
        price: "Слишком дорого для меня",
        not_using: "Я больше не пользуюсь Moneytor",
        bank_not_supported: "Мой банк или провайдер не поддерживается",
        data_issues: "Проблемы с данными или синхронизацией",
        missing_feature: "Не хватает нужной мне функции",
        too_complicated: "Слишком сложно разобраться",
        privacy: "Опасения о приватности и безопасности",
        competitor: "Перешёл на другое решение",
        done_checking: "Просто посмотрел, мне хватило",
        other: "Другое (расскажите нам)",
      },
        reasonRequired: "Пожалуйста, выберите причину",
        otherReasonRequiresText: "Вы выбрали 'Другое', расскажите подробнее",
    },
    generalError: {
      errorContext: "Упс, произошла ошибка — это не вы, это мы :) Вы можете вернуться на предыдущую страницу или попробовать позже. Мы исправим проблему!",
      returnButton: "Назад"
    },
    stockInfo: {
      yesefText: "Актуально для тех, чей доход превышает 721 560 шекелей брутто за налоговый год (на 2025 г.). Отметка дополнительного налога увеличит налог на прирост капитала на 5% в итоговом расчёте стоимости",
      offsetLosses: "Если в портфеле есть убытки капитала, их можно зачесть против налога на прирост капитала. Убытки будут зачтены пропорционально прибыли каждой акции"
    },
    rsuInfo: {
      yesefText: "Актуально для тех, чей доход превышает 721 560 шекелей брутто за налоговый год (на 2025 г.). Отметка дополнительного налога увеличит предельный налог на 3% и налог на прирост капитала на 5%",
      twoyearsRSU: "Чтобы воспользоваться налогом на прирост капитала (25%) на разницу между ценой выделения и текущей ценой, необходимо подождать два года с момента выделения до продажи. Если вы отметили срок продажи как «немедленный», предельный налог будет применяться ко всем новым выделениям",
      twoyearsOption: "При исполнении опционов необходимо подождать не менее двух лет с даты выделения для применения налога на прирост капитала (25%). Если вы отметили «немедленно», предельный налог применяется к опционам, выделенным менее двух лет назад",
      IPOMessage: "Эти поля актуальны только если компания публичная и вы получили выделение опционов менее чем за 90 дней до даты IPO"
    },
    shareForm: {
      uninvestedCash: "Неинвестированные средства",
      minimumFee: "Минимальная комиссия",
      custodyFee: "Плата за хранение",
      securityName: "Название ценной бумаги",
      price: "Цена",
      ipoDate: "Дата IPO",
      ipoPrice: "Цена IPO",
      marginalTaxBracket: "Предельная налоговая ставка",
      afterTwoYears: "Через два года",
      immediate: "Немедленно",
    },
    formLabels: {
      firstName: "Имя",
      lastName: "Фамилия",
      idNumber: "Номер удостоверения",
      email: "Эл. почта",
      phone: "Телефон",
      save: "Сохранить",
      saving: "Сохранение...",
      address: "Адрес",
      personalDetails: "Личные данные"
    }
  }
} as const;

/**
 * Backward-compatible export.
 *
 * Existing code that does `Text.someKey` still works because `Text` now
 * points to the HEB branch. New code should use `Text.HEB.someKey` or
 * `const { t } = useLanguage(); t(Text).someKey`.
 */
export const Text = _shared.HEB;

/**
 * Bilingual export for components that have migrated to useLanguage().
 */
export const TextI18n = _shared;
